import React, { Component } from "react";
import { Helmet } from "react-helmet";
import NewHero from "../components/home/new-hero";
import NewTrustMetrics from "../components/home/new-trust-metrics";
import NewIndustryVerticals from "../components/home/new-industry-verticals";
import NewThreePillars from "../components/home/new-three-pillars";
import NewWhyUs from "../components/home/new-why-us";
import NewProducts from "../components/home/new-products";
import NewCustomerProof from "../components/home/new-customer-proof";
import NewInsights from "../components/home/new-insights";

class HomeV2 extends Component {
  componentDidMount() {
    // GA is already initialized and pageview fired by App-v2.js — do not double-initialize here.
  }

  render() {
    return (
      <React.Fragment>
        <Helmet defer={false}>
          {/* ── Title — preserves exact legacy title ── */}
          <title>Enterprise Software Engineering Since 1992 | Avani Cimcon</title>

          {/* ── Meta description — expanded, keyword-rich, under 160 chars ── */}
          <meta
            name="description"
            content="Enterprise software engineering since 1992. Legacy modernization and AI enablement for Travel, Healthcare, Insurance and Legal. 200+ global clients. ISO 9001 certified."
          />

          {/* ── Legacy keywords — preserved exactly as they appear in production ── */}
          <meta
            name="keywords"
            content="custom software development, software solution application, software development, software development consulting, software development services, web development software, it solutions and services, it services, it solutions, travel solutions, insurance solutions, financial services, travel solution provider, online travel solutions, online booking software, booking engines, content management systems, software development consultancy, customized content management, content management, booking management, enterprise software solutions, custom software development company, custom software development services, enterprise solutions, systems architecture design, custom software applications, inventory management, insurance management software, internet booking engines, travel management system, reservation solutions, tour operator software system, central reservation systems, business rules engine, business rules management system, brms, business software solutions, enterprise data exchange, marketing automation, AI solutions, enterprise AI, machine learning, legacy modernization, managed services, application maintenance, forward deployed engineers, ISO 9001"
          />

          {/* ── Site verification ── */}
          <meta name="google-site-verification" content="zyXlIk9KO1aoC7gY47TEiOJTEqZyN0Jtr8VtHZJ0Wps" />

          {/* ── Robots ── */}
          <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />

          {/* ── Canonical ── */}
          <link rel="canonical" href="https://www.avanicimcon.com/" />

          {/* ── Open Graph ── */}
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://www.avanicimcon.com/" />
          <meta property="og:title" content="Enterprise Software Engineering Since 1992 | Avani Cimcon" />
          <meta property="og:description" content="Enterprise software engineering since 1992. Managed services, legacy modernization and AI enablement across Travel, Healthcare, Insurance, Fintech and Legal. 200+ clients in 70+ countries. ISO 9001 certified." />
          <meta property="og:image" content="https://www.avanicimcon.com/images/og-homepage.jpg" />
          <meta property="og:site_name" content="Avani Cimcon Technologies" />
          <meta property="og:locale" content="en_US" />

          {/* ── Twitter Card ── */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="Enterprise Software Engineering Since 1992 | Avani Cimcon" />
          <meta name="twitter:description" content="Enterprise software engineering since 1992. Managed services, legacy modernization and AI enablement. 200+ clients in 70+ countries." />
          <meta name="twitter:image" content="https://www.avanicimcon.com/images/og-homepage.jpg" />

          {/* ── JSON-LD Structured Data ── */}
          <script type="application/ld+json">{`
            {
              "@context": "https://schema.org",
              "@graph": [
                {
                  "@type": "Organization",
                  "@id": "https://www.avanicimcon.com/#organization",
                  "name": "Avani Cimcon Technologies",
                  "url": "https://www.avanicimcon.com/",
                  "logo": "https://www.avanicimcon.com/images/logo.png",
                  "foundingDate": "1992",
                  "description": "Enterprise software engineering company providing cutting-edge software solutions since 1992. Specializing in managed services, legacy modernization and AI enablement across Travel, Healthcare, Insurance, Fintech and Legal verticals.",
                  "numberOfEmployees": {"@type": "QuantitativeValue", "minValue": 50, "maxValue": 500},
                  "hasCredential": {
                    "@type": "EducationalOccupationalCredential",
                    "credentialCategory": "ISO 9001:2015"
                  },
                  "areaServed": {"@type": "GeoShape", "description": "70+ countries worldwide"},
                  "contactPoint": [
                    {"@type": "ContactPoint", "telephone": "+1-609-403-9000", "contactType": "sales", "areaServed": "US"},
                    {"@type": "ContactPoint", "telephone": "+91-79-2687-2171", "contactType": "sales", "areaServed": "IN"},
                    {"@type": "ContactPoint", "email": "inquiry@avanicimcon.com", "contactType": "customer support"}
                  ],
                  "address": {"@type": "PostalAddress", "addressLocality": "Princeton", "addressRegion": "NJ", "addressCountry": "US"},
                  "knowsAbout": [
                    "Enterprise Software Development",
                    "Custom Software Development",
                    "Legacy System Modernization",
                    "AI Enablement",
                    "Managed Services",
                    "Travel Technology",
                    "Healthcare IT",
                    "Insurance Technology",
                    "Legal Technology",
                    "API Management",
                    "Business Rules Engine",
                    "ISO 9001 Quality Management"
                  ],
                  "sameAs": [
                    "https://www.linkedin.com/company/avani-cimcon-technology-limited/",
                    "https://www.crunchbase.com/organization/avani-cimcon-technologies"
                  ]
                },
                {
                  "@type": "WebSite",
                  "@id": "https://www.avanicimcon.com/#website",
                  "url": "https://www.avanicimcon.com/",
                  "name": "Avani Cimcon Technologies",
                  "publisher": {"@id": "https://www.avanicimcon.com/#organization"}
                },
                {
                  "@type": "WebPage",
                  "@id": "https://www.avanicimcon.com/#webpage",
                  "url": "https://www.avanicimcon.com/",
                  "name": "Enterprise Software Engineering Since 1992 | Avani Cimcon",
                  "isPartOf": {"@id": "https://www.avanicimcon.com/#website"},
                  "about": {"@id": "https://www.avanicimcon.com/#organization"},
                  "description": "Enterprise software engineering since 1992. Managed services, legacy modernization and AI enablement across Travel, Healthcare, Insurance, Fintech and Legal. 200+ clients in 70+ countries. ISO 9001 certified.",
                  "breadcrumb": {
                    "@type": "BreadcrumbList",
                    "itemListElement": [{"@type": "ListItem", "position": 1, "name": "Home", "item": "https://www.avanicimcon.com/"}]
                  }
                },
                {
                  "@type": "ProfessionalService",
                  "@id": "https://www.avanicimcon.com/#service",
                  "name": "Avani Cimcon Technologies",
                  "url": "https://www.avanicimcon.com/",
                  "hasOfferCatalog": {
                    "@type": "OfferCatalog",
                    "name": "Enterprise Software Services",
                    "itemListElement": [
                      {"@type": "Offer", "itemOffered": {"@type": "Service", "name": "Managed Services", "description": "24x7 application monitoring, maintenance, upgradation and support"}},
                      {"@type": "Offer", "itemOffered": {"@type": "Service", "name": "AI Enablement", "description": "AI as an intelligence layer on existing enterprise systems"}},
                      {"@type": "Offer", "itemOffered": {"@type": "Service", "name": "Forward Deployed Engineers", "description": "On-site AI engineers and architects for deep system integration"}},
                      {"@type": "Offer", "itemOffered": {"@type": "Service", "name": "Travel Technology", "description": "Airline reservation, hotel management, travel ERP and booking engines"}},
                      {"@type": "Offer", "itemOffered": {"@type": "Service", "name": "Healthcare IT", "description": "Hospital information systems, EMR, patient management and healthcare analytics"}}
                    ]
                  }
                }
              ]
            }
          `}</script>
        </Helmet>

        <main id="main-content">
          <NewHero />
          <NewTrustMetrics />
          <NewIndustryVerticals />
          <NewThreePillars />
          <NewWhyUs />
          <NewProducts />
          <NewCustomerProof />
          <NewInsights />
        </main>

      </React.Fragment>
    );
  }
}

export default HomeV2;
